/* eslint-disable no-unused-vars */
import { useCallback, useRef, useContext } from 'react';
import { useSignal, useComputed } from '@preact/signals-react';
import { Buttons, DropDownWrapper, MenuItem } from 'components';
import { Filter as FilterIcon, ArrowDown } from 'assets/icons';
import * as S from './FiltersBtn.styled';
import { FilterContent } from './FilterContent';
import { ManageCampaignsContext } from 'contexts';

const btnCustomOpen = {
  color: 'rgb(59, 137, 246)', // primary_500
};

export const FiltersBtn = () => {
  const { currentFilter$ } = useContext(ManageCampaignsContext);
  const isOpen$ = useSignal(false);

  const btnRef = useRef(null);

  const menuClick = useCallback((value) => {
    currentFilter$.value = value;
  }, []);

  return (
    <div ref={btnRef} style={{ position: 'relative', marginRight: '8px' }}>
      <Buttons.QuaternaryNormal
        id='chooseFiltersBtn'
        //ref={btnRef}
        icon={<FilterIcon />}
        isPressed={isOpen$.value}
        style={isOpen$.value ? btnCustomOpen : {}}
        onClick={() => (isOpen$.value = !isOpen$.value)}
      >
        Filters
      </Buttons.QuaternaryNormal>
      {useComputed(() => (
        <>
          {isOpen$.value && (
            <DropDownWrapper
              isOpen$={isOpen$}
              targetRef={btnRef}
              style={{ right: '0', width: 'unset' }}
              outSideClickAction={() => menuClick('campaignStatus')}
            >
              <S.Container>
                <S.MenuItemsContainer>
                  <MenuItem
                    value='campaignStatus'
                    onClick={(value) => menuClick(value)}
                    height={40}
                    isSelected={currentFilter$.value === 'campaignStatus'}
                  >
                    <S.Title isHidden={currentFilter$.value === 'campaignStatus'}>
                      Campaign Status <ArrowDown />
                    </S.Title>
                  </MenuItem>
                  {/* <MenuItem
                    onClick={(value) => menuClick(value, 210)}
                    value='campaignType'
                    height={40}
                    isSelected={currentFilter$.value === 'campaignType'}
                  >
                    <S.Title isHidden={currentFilter$.value === 'campaignType'}>
                      Campaign Type <ArrowDown />
                    </S.Title>
                  </MenuItem> */}
                  <MenuItem
                    onClick={(value) => menuClick(value)}
                    value='targetedGeos'
                    height={40}
                    isSelected={currentFilter$.value === 'targetedGeos'}
                  >
                    <S.Title isHidden={currentFilter$.value === 'targetedGeos'}>
                      Targeted Geos <ArrowDown />
                    </S.Title>
                  </MenuItem>
                  <MenuItem
                    onClick={(value) => menuClick(value)}
                    value='applicationType'
                    height={40}
                    isSelected={currentFilter$.value === 'applicationType'}
                  >
                    <S.Title isHidden={currentFilter$.value === 'applicationType'}>
                      Application Type <ArrowDown />
                    </S.Title>
                  </MenuItem>
                </S.MenuItemsContainer>
                <FilterContent.CampaignStatus
                  style={{ width: '188px' }}
                  isShow={currentFilter$.value === 'campaignStatus'}
                  isOpen$={isOpen$}
                />
                <FilterContent.CampaignType
                  style={{ width: '136px' }}
                  isShow={currentFilter$.value === 'campaignType'}
                  isOpen$={isOpen$}
                />
                <FilterContent.TargetedGeos
                  style={{ width: '250px' }}
                  isShow={currentFilter$.value === 'targetedGeos'}
                  isOpen$={isOpen$}
                  menuClick={menuClick}
                />
                <FilterContent.ApplicationType
                  style={{ width: '180px' }}
                  isShow={currentFilter$.value === 'applicationType'}
                  isOpen$={isOpen$}
                />
              </S.Container>
            </DropDownWrapper>
          )}
        </>
      ))}
    </div>
  );
};
